var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgProfile = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.0829 25.3462C24.6239 23.2598 27 19.4074 27 15C27 8.37258 21.6274 3 15 3C8.37258 3 3 8.37258 3 15C3 19.4019 5.3701 23.2502 8.90378 25.3384V18.0514H21.0829V25.3462ZM19.5307 26.1153V19.6036H10.456V26.1098C11.8576 26.6837 13.3919 27 15 27C16.6031 27 18.1327 26.6857 19.5307 26.1153ZM14.9933 9.01653C16.6385 9.01653 17.9784 10.3565 17.9784 12.0016C17.9784 13.6467 16.6385 14.9867 14.9933 14.9867C13.3482 14.9867 12.0083 13.6467 12.0083 12.0016C12.0083 10.3565 13.3482 9.01653 14.9933 9.01653ZM14.9933 7.46429C12.4859 7.46429 10.4561 9.49414 10.4561 12.0016C10.4561 14.5091 12.4859 16.5389 14.9933 16.5389C17.5008 16.5389 19.5307 14.5091 19.5307 12.0016C19.5307 9.49414 17.5008 7.46429 14.9933 7.46429Z",
    fill: "#006EF5"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgProfile);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/Profile.51a49fbd084371ee582477d3fab70a6f.svg";